import { style } from '@vanilla-extract/css';
import { themeVars } from '@customerio/pluma-components/css/theme-tokens';

export const categoryGroup = style(
  {
    borderBottom: `${themeVars.border['width-0125']} solid ${themeVars.color['border-minimal']}`,
    selectors: {
      '&:last-child': {
        borderBottom: 'none',
      },
    },
  },
  'category-group',
);
